<template>
  <v-container fluid class="mt-4 px-4">
    <!-- ============================================================
         ENCABEZADO
         ============================================================ -->
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-h5 font-weight-bold">
            <v-icon left color="deep-purple">mdi-filter-outline</v-icon>
            Dashboard — Embudo de Ventas
            <v-spacer></v-spacer>
            <v-btn color="deep-purple darken-1" dark @click="consultar" :loading="cargando" id="btn-consultar-embudo">
              <v-icon left>mdi-refresh</v-icon>
              Consultar
            </v-btn>
          </v-card-title>

          <!-- FILTROS EN CASCADA -->
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" sm="6" md="3">
                <v-menu v-model="menuFechaInicio" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="fechaInicio" label="Fecha Inicio" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined hide-details></v-text-field>
                  </template>
                  <v-date-picker v-model="fechaInicio" @input="menuFechaInicio = false" locale="es-MX"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-menu v-model="menuFechaFin" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="fechaFin" label="Fecha Fin" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined hide-details></v-text-field>
                  </template>
                  <v-date-picker v-model="fechaFin" @input="menuFechaFin = false" locale="es-MX"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-select v-model="escuela" :items="escuelas" item-text="nombre" item-value="id" label="Escuela" dense outlined hide-details prepend-icon="mdi-school"></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-select v-model="plantelesSel" :items="planteles" item-text="plantel" item-value="id_plantel" label="Plantel (opcional)" dense outlined hide-details multiple chips small-chips prepend-icon="mdi-map-marker"></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ============================================================
         PIRÁMIDE INVERTIDA — 4 NIVELES
         ============================================================ -->
    <v-row v-if="datosCargados" class="mt-4">

      <!-- NIVEL 1: TOTAL CONTACTOS -->
      <v-col cols="12">
        <v-card class="embudo-nivel nivel-1 elevation-4" @click="abrirNivel(1)">
          <v-card-text class="text-center py-5">
            <div class="text-overline white--text mb-1">
              <v-icon color="white" small>mdi-account-group</v-icon>
              NIVEL 1 — Total Contactos
            </div>
            <div class="text-h2 white--text font-weight-bold">{{ embudo.nivel1.total }}</div>
            <div class="text-caption white--text mt-1">Contactos únicos en el periodo</div>
            <v-btn small outlined color="white" class="mt-2" @click.stop="abrirLab(1)">
              <v-icon left small>mdi-robot</v-icon>Laboratorio IA
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Calidad por Fuente -->
      <v-col cols="12" v-if="embudo.nivel1.por_fuente.length">
        <v-card class="shadowCard">
          <v-card-title class="text-subtitle-2 grey--text text--darken-2">
            <v-icon left small color="indigo">mdi-chart-bar</v-icon>
            Calidad de Lead por Fuente
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" v-for="f in embudo.nivel1.por_fuente" :key="f.fuente">
                <v-card outlined class="pa-3 text-center cursor-pointer" @click="abrirFuente(f, 'total')">
                  <div class="text-subtitle-1 font-weight-bold">{{ f.fuente || 'Sin fuente' }}</div>
                  <div class="text-h5 indigo--text">{{ f.total }}</div>
                  <v-row class="mt-1 text-caption">
                    <v-col class="green--text hover-list" @click.stop="abrirFuente(f, 'completos')">✔ {{ f.completos }} completos</v-col>
                    <v-col class="red--text hover-list" @click.stop="abrirFuente(f, 'incompletos')">✖ {{ f.incompletos }} incompletos</v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- NIVEL 2: BOT FILTER -->
      <v-col cols="12" md="6">
        <v-card class="embudo-nivel nivel-2 elevation-4" @click="abrirNivel(2, 'completos')">
          <v-card-text class="text-center py-4">
            <div class="text-overline white--text mb-1">
              <v-icon color="white" small>mdi-check-circle</v-icon>
              NIVEL 2 — Completos
            </div>
            <div class="text-h3 white--text font-weight-bold">{{ embudo.nivel2.completos }}</div>
            <div class="text-caption white--text mt-1">Finalizaron el bot</div>
            <v-btn small outlined color="white" class="mt-2" @click.stop="abrirLab(2, 'completos')">
              <v-icon left small>mdi-robot</v-icon>Lab IA
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="embudo-nivel nivel-2b elevation-4" @click="abrirNivel(2, 'incompletos')">
          <v-card-text class="text-center py-4">
            <div class="text-overline white--text mb-1">
              <v-icon color="white" small>mdi-close-circle</v-icon>
              NIVEL 2 — Incompletos (Caida)
            </div>
            <div class="text-h3 white--text font-weight-bold">{{ embudo.nivel2.incompletos }}</div>
            <div class="text-caption white--text mt-1">Abandonaron el bot</div>
            <v-btn small outlined color="white" class="mt-2" @click.stop="abrirLab(2, 'incompletos')">
              <v-icon left small>mdi-robot</v-icon>Lab IA
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- NIVEL 3: SEGUIMIENTO -->
      <v-col cols="12" md="4">
        <v-card class="embudo-nivel nivel-3a elevation-4" @click="abrirNivel(3, 'mas5')">
          <v-card-text class="text-center py-4">
            <div class="text-overline white--text mb-1">
              <v-icon color="white" small>mdi-fire</v-icon>
              Interacción +5
            </div>
            <div class="text-h3 white--text font-weight-bold">{{ embudo.nivel3.mas5 }}</div>
            <v-btn small outlined color="white" class="mt-2" @click.stop="abrirLab(3, 'mas5')">
              <v-icon left small>mdi-robot</v-icon>Lab IA
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="embudo-nivel nivel-3c elevation-4" @click="abrirNivel(3, 'rescatados')">
          <v-card-text class="text-center py-4">
            <div class="text-overline white--text mb-1">
              <v-icon color="white" small>mdi-lifebuoy</v-icon>
              Rescate Manual
            </div>
            <div class="text-h3 white--text font-weight-bold">{{ embudo.nivel3.rescatados }}</div>
            <div class="text-caption white--text mt-1">Tasa: {{ embudo.nivel3.tasa_rescate }}%</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- NIVEL 4: CIERRE -->
      <v-col cols="12" md="4">
        <v-card class="embudo-nivel nivel-4 elevation-4" @click="abrirNivel(4)">
          <v-card-text class="text-center py-4">
            <div class="text-overline white--text mb-1">
              <v-icon color="white" small>mdi-cash-check</v-icon>
              NIVEL 4 — Inscritos
            </div>
            <div class="text-h3 white--text font-weight-bold">{{ embudo.nivel4.inscritos }}</div>
            <div class="text-caption white--text mt-1">Tasa Cierre: {{ embudo.nivel4.tasa_cierre }}%</div>
            <div class="text-caption white--text">Resp. Prom: {{ embudo.nivel4.promedio_respuesta_min }} min</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ========================
         DIALOGO — Lista de prospectos del nivel
         ======================== -->
    <v-dialog v-model="dialogNivel" max-width="900" scrollable>
      <v-card>
        <v-card-title class="deep-purple white--text">
          <v-icon left color="white">mdi-account-group</v-icon>
          {{ tituloDialogo }} ({{ prospectosDlg.length }})
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogNivel = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="headersProspectos"
            :items="prospectosDlg"
            dense
            :items-per-page="15"
            mobile-breakpoint="200"
          >
            <template v-slot:item.tipo_bot="{ item }">
              <v-chip x-small :color="item.tipo_bot === 'completo' ? 'green' : item.tipo_bot === 'incompleto' ? 'red' : 'grey'" dark>
                {{ item.tipo_bot }}
              </v-chip>
            </template>
            <template v-slot:item.interacciones="{ item }">
              <v-chip x-small :color="item.interacciones >= 5 ? 'orange darken-2' : 'blue-grey'" dark>
                {{ item.interacciones }}
              </v-chip>
            </template>
            <template v-slot:item.es_rescatado="{ item }">
              <v-chip x-small :color="item.es_rescatado ? 'teal' : 'transparent'" dark>
                {{ item.es_rescatado ? '✔' : '' }}
              </v-chip>
            </template>
            <template v-slot:item.inscrito="{ item }">
              <v-chip v-if="item.inscrito" x-small color="green darken-1" dark>SÍ</v-chip>
              <v-chip v-else x-small color="grey lighten-1" dark>NO</v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="exportarCSV(prospectosDlg, tituloDialogo)">
            <v-icon left small>mdi-file-delimited</v-icon>Exportar CSV
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogNivel = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========================
         DIALOGO — LABORATORIO IA
         ======================== -->
    <v-dialog v-model="dialogLab" max-width="820" persistent>
      <v-card>
        <v-card-title class="deep-purple darken-3 white--text">
          <v-icon left color="white">mdi-robot</v-icon>
          Laboratorio IA — {{ tituloLab }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogLab = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="info" outlined dense class="mb-3">
            <strong>Cohorte:</strong> {{ prospectosDlg.length }} prospectos con twilio.
            Se procesaran en lotes de 50.
          </v-alert>

          <v-select
            v-model="promptSeleccionado"
            :items="promptsGuardados"
            item-text="nombre"
            item-value="id"
            label="Cargar prompt guardado"
            dense outlined
            @change="cargarPrompt"
            class="mb-2"
          ></v-select>

          <v-expansion-panels flat outlined class="mb-4 no-transition">
            <v-expansion-panel>
              <v-expansion-panel-header class="grey lighten-4 py-2 border-bottom">
                <div class="d-flex align-center">
                  <v-icon left small color="deep-purple">mdi-cog-outline</v-icon>
                  <span class="text-subtitle-2 font-weight-bold">Configuración de Procesamiento (Opcional)</span>
                </div>
                <template v-slot:actions>
                  <v-icon color="deep-purple">mdi-chevron-down</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-4 border">
                <v-row dense align="center">
                  <v-col cols="12">
                    <div class="d-flex align-center justify-space-between mb-2">
                      <v-switch v-model="filtrosLab.modoManual" label="Modo Selección Manual" color="deep-purple" dense hide-details class="ma-0 pa-0"></v-switch>
                      <v-btn small text color="red darken-1" @click="resetearFiltros">
                        <v-icon left small>mdi-refresh</v-icon>Resetear todo
                      </v-btn>
                    </div>
                  </v-col>

                  <!-- Filtros Automáticos -->
                  <v-col cols="12" sm="6">
                    <v-menu v-model="filtrosLab.menuInicio" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto" :disabled="filtrosLab.modoManual">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="filtrosLab.fechaInicio" label="Mensajes desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined hide-details class="mb-2" :disabled="filtrosLab.modoManual"></v-text-field>
                      </template>
                      <v-date-picker 
                        v-model="filtrosLab.fechaInicio" 
                        @input="filtrosLab.menuInicio = false" 
                        locale="es-MX"
                        :min="fechaInicio"
                        :max="filtrosLab.fechaFin || fechaFin"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu v-model="filtrosLab.menuFin" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto" :disabled="filtrosLab.modoManual">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="filtrosLab.fechaFin" label="Mensajes hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined hide-details class="mb-2" :disabled="filtrosLab.modoManual"></v-text-field>
                      </template>
                      <v-date-picker 
                        v-model="filtrosLab.fechaFin" 
                        @input="filtrosLab.menuFin = false" 
                        locale="es-MX"
                        :min="filtrosLab.fechaInicio || fechaInicio"
                        :max="fechaFin"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-slider v-model="filtrosLab.limitLeads" label="Máx. Leads" min="1" max="100" thumb-label="always" dense hide-details class="mt-4" color="deep-purple" :disabled="filtrosLab.modoManual"></v-slider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-slider v-model="filtrosLab.limitMensajes" label="Msgs/Chat" min="1" max="50" thumb-label="always" dense hide-details class="mt-4" color="deep-purple" :disabled="filtrosLab.modoManual"></v-slider>
                  </v-col>
                </v-row>

                <!-- Selección Manual (Tabla) -->
                <v-expand-transition>
                  <div v-if="filtrosLab.modoManual" class="mt-6 pa-3 blue-grey lighten-5 rounded">
                    <div class="text-caption font-weight-bold grey--text mb-2">SELECCIÓN MANUAL DE LEAD Y MENSAJES:</div>
                    <v-data-table
                      v-model="filtrosLab.prospectosSeleccionados"
                      :headers="[
                        { text: 'Nombre', value: 'nombre_completo' },
                        { text: 'Bot', value: 'tipo_bot' },
                        { text: 'Acción', value: 'actions', sortable: false }
                      ]"
                      :items="prospectosDlg"
                      show-select
                      item-key="twilio"
                      dense
                      class="elevation-0 transparent"
                      :items-per-page="5"
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-btn x-small color="deep-purple" dark @click="abrirMensajesManual(item)">
                          <v-icon left x-small>mdi-chat-processing</v-icon>Elegir mensajes
                        </v-btn>
                      </template>
                    </v-data-table>
                  </div>
                </v-expand-transition>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-textarea
            v-model="masterPrompt"
            :label="'Master Prompt para ' + tituloLab"
            rows="5"
            dense outlined
            placeholder="Ej: Analiza estas conversaciones e identifica los principales motivos por los que el lead no completo el flujo del bot..."
            class="mb-2"
          ></v-textarea>

          <v-row dense align="center" class="mb-2">
            <v-col cols="8">
              <v-text-field v-model="nombrePrompt" label="Nombre del prompt (para guardar)" dense outlined hide-details></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn color="deep-purple" dark block @click="guardarPrompt" :loading="guardandoPrompt">
                <v-icon left small>mdi-content-save</v-icon>Guardar
              </v-btn>
            </v-col>
          </v-row>

            <v-alert type="info" text dense class="mt-4 mb-0 text-caption rounded-lg border-purple" border="left">
              <v-icon left color="info" small>mdi-information-outline</v-icon>
              <strong>Muestreo Inteligente:</strong> Para tu análisis, el sistema ha seleccionado automáticamente a los <strong>{{ infoTokens ? infoTokens.procesados : 50 }} contactos con más interacciones</strong> del cohorte actual. Esto asegura que la IA analice conversaciones valiosas incluso en grupos grandes.
            </v-alert>

            <v-card outlined class="mt-4 pa-0 overflow-hidden" :class="cargandoTranscripciones ? 'elevation-1 opacity-60' : ''">
              <v-toolbar flat dense color="deep-purple lighten-5" height="32">
                <v-icon left x-small color="deep-purple">mdi-sync</v-icon>
                <span class="text-caption font-weight-bold deep-purple--text">RESUMEN DE ESTIMACIÓN — Dinámico</span>
                <v-spacer></v-spacer>
                <v-progress-linear v-if="cargandoTranscripciones" indeterminate height="2" color="deep-purple" absolute bottom></v-progress-linear>
                <v-icon v-else right x-small color="green" title="Actualizado">mdi-check-circle</v-icon>
              </v-toolbar>
              <v-divider></v-divider>
              <v-row no-gutters class="pa-3 text-body-2" align="center">
                <v-col cols="12" sm="6">
                  <div class="mb-1"><strong>Prospectos:</strong> 
                    <span :class="infoTokens ? '' : 'grey--text'">{{ infoTokens ? infoTokens.procesados : '-' }} / {{ infoTokens ? infoTokens.total_prospectos : '-' }}</span>
                  </div>
                  <div class="mb-1"><strong>Mensajes totales:</strong> 
                    <span :class="infoTokens ? '' : 'grey--text'">{{ infoTokens ? infoTokens.total_mensajes : '-' }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" class="text-right">
                  <div class="mb-1"><strong>Tokens Est.:</strong> 
                    <v-chip x-small color="grey lighten-2" class="font-weight-bold">~{{ infoTokens ? infoTokens.tokens_input : '0' }}</v-chip>
                  </div>
                  <div class="mb-1 green--text text--darken-3 font-weight-bold">
                    <strong>Costo Entrada:</strong> ${{ infoTokens ? infoTokens.costo_entrada_usd : '0.000000' }} USD
                  </div>
                </v-col>
              </v-row>
              <v-alert v-if="infoTokens && infoTokens.truncado" x-small dense type="warning" class="ma-0 text-caption rounded-0">Limitado por la configuración actual (se analizan los más activos).</v-alert>
            </v-card>

          <!-- Nueva Visualización de IA Estructurada -->
          <div v-if="respuestaIA" class="mt-6">
            <div class="d-flex align-center justify-space-between mb-3 px-1">
              <div class="text-h6 deep-purple--text font-weight-bold d-flex align-center">
                <v-icon color="deep-purple" class="mr-2">mdi-robot-outline</v-icon>
                Resultado del Análisis IA
              </div>
              <v-btn-toggle v-model="verJSON" mandatory dense color="deep-purple" borderless>
                <v-btn :value="false" x-small>
                  <v-icon left x-small>mdi-eye</v-icon>Amigable
                </v-btn>
                <v-btn :value="true" x-small>
                  <v-icon left x-small>mdi-code-json</v-icon>Raw JSON
                </v-btn>
              </v-btn-toggle>
            </div>

            <!-- VISTA AMIGABLE -->
            <v-card v-if="!verJSON && diagnosticoIA" flat class="transparent">
              <!-- Resumen Ejecutivo -->
              <v-card v-if="diagnosticoIA.resumen" class="mb-4 pa-4 rounded-lg bg-resumen border-dashed" outlined>
                <div class="text-subtitle-2 font-weight-bold grey--text text--darken-2 mb-2 d-flex align-center">
                  <v-icon small left color="deep-purple">mdi-text-box-search-outline</v-icon>
                  RESUMEN EJECUTIVO
                </div>
                <div class="text-body-1 line-height-relaxed">
                  {{ diagnosticoIA.resumen }}
                </div>
              </v-card>

              <!-- Diagnóstico por Categorías -->
              <v-row dense>
                <!-- Hallazgos Clave -->
                <v-col cols="12" md="6" v-if="diagnosticoIA.hallazgos.length">
                  <v-card class="fill-height pa-3 rounded-lg border-purple-light" outlined elevation="0">
                    <div class="text-overline font-weight-bold indigo--text mb-2 d-flex align-center">
                      <v-icon small left color="indigo">mdi-magnify-scan</v-icon>
                      Hallazgos Clave
                    </div>
                    <v-list dense class="pa-0 transparent">
                      <v-list-item v-for="(h, i) in diagnosticoIA.hallazgos" :key="'h'+i" class="px-0 min-h-auto mb-2 align-start">
                        <v-icon x-small color="indigo" class="mt-1 mr-2">mdi-circle-small</v-icon>
                        <v-list-item-content class="pa-0">
                          <div class="text-body-2">{{ h }}</div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <!-- Patrones Comunes -->
                <v-col cols="12" md="6" v-if="diagnosticoIA.patrones.length">
                  <v-card class="fill-height pa-3 rounded-lg border-blue-light" outlined elevation="0">
                    <div class="text-overline font-weight-bold blue--text text--darken-3 mb-2 d-flex align-center">
                      <v-icon small left color="blue darken-3">mdi-trending-up</v-icon>
                      Patrones Comunes
                    </div>
                    <v-list dense class="pa-0 transparent">
                      <v-list-item v-for="(p, i) in diagnosticoIA.patrones" :key="'p'+i" class="px-0 min-h-auto mb-2 align-start">
                        <v-icon x-small color="blue darken-1" class="mt-1 mr-2">mdi-circle-small</v-icon>
                        <v-list-item-content class="pa-0">
                          <div class="text-body-2">{{ p }}</div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <!-- Oportunidades -->
                <v-col cols="12" md="6" v-if="diagnosticoIA.oportunidades.length">
                  <v-card class="fill-height pa-3 rounded-lg border-orange-light mt-2" outlined elevation="0">
                    <div class="text-overline font-weight-bold orange--text text--darken-3 mb-2 d-flex align-center">
                      <v-icon small left color="orange darken-3">mdi-bullseye-arrow</v-icon>
                      Oportunidades Detectadas
                    </div>
                    <v-list dense class="pa-0 transparent">
                      <v-list-item v-for="(o, i) in diagnosticoIA.oportunidades" :key="'o'+i" class="px-0 min-h-auto mb-2 align-start">
                        <v-icon x-small color="orange darken-3" class="mt-1 mr-2">mdi-circle-small</v-icon>
                        <v-list-item-content class="pa-0">
                          <div class="text-body-2">{{ o }}</div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <!-- Recomendaciones -->
                <v-col cols="12" md="6" v-if="diagnosticoIA.recomendaciones.length">
                  <v-card class="fill-height pa-3 rounded-lg border-teal-light mt-2" outlined elevation="0">
                    <div class="text-overline font-weight-bold teal--text text--darken-2 mb-2 d-flex align-center">
                      <v-icon small left color="teal darken-2">mdi-lightbulb-outline</v-icon>
                      Recomendaciones Estratégicas
                    </div>
                    <v-list dense class="pa-0 transparent">
                      <v-list-item v-for="(r, i) in diagnosticoIA.recomendaciones" :key="'r'+i" class="px-0 min-h-auto mb-2 align-start">
                        <v-icon x-small color="teal" class="mt-1 mr-2">mdi-check-decagram-outline</v-icon>
                        <v-list-item-content class="pa-0">
                          <div class="text-body-2">{{ r }}</div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Módulo de Ejecución y Costos Reales -->
              <v-card outlined class="mt-6 pa-0 rounded-lg overflow-hidden border-grey-light">
                <v-toolbar flat dense color="grey lighten-4" height="40">
                  <v-icon left small color="grey darken-2">mdi-chart-areaspline</v-icon>
                  <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3">Auditoría de Consumo y Ejecución</span>
                </v-toolbar>
                <v-simple-table dense class="comparativa-table">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left font-weight-bold grey--text text--darken-1">Métrica</th>
                        <th class="text-center font-weight-bold grey--text text--darken-1">Estimación Preiva</th>
                        <th class="text-center font-weight-bold deep-purple--text">Ejecución Real</th>
                        <th class="text-center font-weight-bold grey--text text--darken-1">Desviación</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><v-icon x-small left>mdi-file-export-outline</v-icon> Tokens Entrada</td>
                        <td class="text-center">{{ datosAuditoria.tokens.estInput || '-' }}</td>
                        <td class="text-center font-weight-bold font-italic">{{ datosAuditoria.tokens.realInput || '-' }}</td>
                        <td class="text-center">
                          <v-chip x-small :color="datosAuditoria.tokens.dev > 20 ? 'orange' : 'green'" dark>
                            {{ datosAuditoria.tokens.dev }}%
                          </v-chip>
                        </td>
                      </tr>
                      <tr>
                        <td><v-icon x-small left>mdi-file-import-outline</v-icon> Tokens Salida</td>
                        <td class="text-center grey--text font-italic">N/A</td>
                        <td class="text-center font-weight-bold font-italic">{{ datosAuditoria.tokens.realOutput || '-' }}</td>
                        <td class="text-center grey--text">-</td>
                      </tr>
                      <tr class="deep-purple lighten-5 font-weight-bold">
                        <td><v-icon x-small left color="deep-purple">mdi-currency-usd</v-icon> Costo Total Estimado</td>
                        <td class="text-center">${{ datosAuditoria.costos.estTotal.toFixed(6) }}</td>
                        <td class="text-center deep-purple--text">
                          ${{ datosAuditoria.costos.realTotal.toFixed(6) }}
                        </td>
                        <td class="text-center">
                           <v-icon small :color="datosAuditoria.costos.dev > 20 ? 'orange' : 'green'">
                             {{ datosAuditoria.costos.dev > 20 ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline' }}
                           </v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <div class="pa-2 grey lighten-4 text-center text-caption font-italic grey--text text--darken-1">
                  * Cálculos basados en tokens reales reportados por GPT-4o-mini ($0.15/1M Input, $0.60/1M Output)
                </div>
              </v-card>

              <!-- Footer Metadatos rápidos -->
              <div class="mt-4 grey--text text-caption d-flex align-center flex-wrap" v-if="diagnosticoIA.metadatos.elapsed || diagnosticoIA.metadatos.chats">
                <v-chip x-small outlined color="deep-purple lighten-1" class="mr-2 mb-1" v-if="diagnosticoIA.metadatos.elapsed">
                  <v-icon x-small left>mdi-clock-outline</v-icon>
                  Tiempo: {{ (diagnosticoIA.metadatos.elapsed / 1000).toFixed(1) }}s
                </v-chip>
                <v-chip x-small outlined color="indigo lighten-1" class="mr-2 mb-1" v-if="diagnosticoIA.metadatos.chats">
                  <v-icon x-small left>mdi-account-search-outline</v-icon>
                  {{ diagnosticoIA.metadatos.chats }} chats analizados
                </v-chip>
              </div>
            </v-card>

            <!-- VISTA RAW JSON (Fallback) -->
            <v-textarea
              v-else
              v-model="respuestaIA"
              label="Respuesta Técnica (JSON)"
              rows="10"
              readonly
              outlined
              background-color="grey lighten-4"
              class="text-monospace-small"
            ></v-textarea>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="green darken-2"
            dark
            @click="enviarAIA"
            :disabled="!infoTokens || !masterPrompt"
            :loading="enviandoIA"
            elevation="2"
            id="btn-enviar-ia"
          >
            <v-icon left>mdi-auto-fix</v-icon>Generar Análisis con IA
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn text @click="exportarTranscripcionesJSON" v-if="transcripcionesLab.length">
            <v-icon left small>mdi-code-json</v-icon>Exportar JSON
          </v-btn>

          <v-btn text @click="dialogLab = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- UI: Seleccion Individual de Mensajes -->
    <v-dialog v-model="dialogMensajesMan" max-width="600">
      <v-card v-if="prospectoMensajesMan">
        <v-card-title class="grey lighten-3 text-subtitle-2">
          Selección de mensajes: {{ prospectoMensajesMan.nombre_completo }}
        </v-card-title>
        <v-card-text class="pa-4" style="max-height: 400px; overflow-y: auto;">
          <div v-if="!transcripcionMensajesMan.length" class="text-center py-4 grey--text font-italic">
            Sin mensajes encontrados para el rango seleccionado.
          </div>
          <v-list dense v-else class="pa-0 transparent">
            <v-list-item v-for="(m, i) in transcripcionMensajesMan" :key="i" 
              class="px-0 mb-3 d-flex flex-column align-stretch" 
              :ripple="false"
              style="min-height: auto;">
              
              <!-- Cabecera de fecha estilo WhatsApp -->
              <div v-if="mostrarCabeceraFecha(i)" class="d-flex justify-center w-100 py-3 mt-1 mb-2">
                <v-chip x-small color="grey lighten-3" class="text-caption grey--text text--darken-2 px-4" style="height: 22px; font-weight: 500; border-radius: 6px;">
                  {{ formatearFechaChat(m.timestamp) }}
                </v-chip>
              </div>

              <div class="d-flex w-100 pa-0">
                <v-list-item-action class="ma-0 mr-2 align-self-start mt-2">
                  <v-checkbox v-model="mensajeSeleccionadosMan[prospectoMensajesMan.twilio]" 
                    :value="i" dense color="deep-purple" hide-details></v-checkbox>
                </v-list-item-action>

                <v-list-item-content class="pa-0">
                  <div :class="m.mio ? 'd-flex justify-end w-100' : 'd-flex justify-start w-100'" style="width: 100%;">
                      <div :class="['chat-bubble shadow-sm', m.mio ? 'bubble-bot' : 'bubble-lead']">
                        <div class="d-flex align-center mb-1">
                          <v-icon x-small :color="m.mio ? 'indigo' : 'green'" class="mr-1">
                            {{ m.mio ? 'mdi-robot' : 'mdi-account' }}
                          </v-icon>
                          <span class="text-overline font-weight-bold" style="line-height:1; font-size: 0.6rem !important;">{{ m.emisor }}</span>
                        </div>
                        
                        <div v-if="m.mensaje" class="text-body-2" style="word-break: break-word;">{{ m.mensaje }}</div>
                        
                        <div v-if="m.media" class="mt-2 rounded overflow-hidden border" style="max-width: 220px;">
                          <v-img :src="m.media" max-width="220" max-height="200" contain class="grey lighten-4">
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="deep-purple lighten-4" size="20"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <div v-if="m.type && m.type !== 'chat'" class="bg-light pa-1 text-center" style="font-size: 0.6rem; background: #eee;">
                            {{ m.type_text }}
                          </div>
                        </div>
                        
                        <div v-if="!m.mensaje && !m.media" class="font-italic grey--text text-caption">
                          [Mensaje interactivo / Sistema]
                        </div>

                        <div class="bubble-time text-right mt-1 grey--text" style="font-size: 0.6rem;">
                          {{ m.timestamp ? m.timestamp.split('T')[1].substring(0,5) : '' }}
                        </div>
                      </div>
                  </div>
                </v-list-item-content>
              </div>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="deep-purple" dark @click="dialogMensajesMan = false">Listo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" top right>
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
export default {
  name: 'EmbudoVentas',

  computed: {
    transcripcionesActuales: function () {
      if (!this.filtrosLab.modoManual) return this.transcripcionesLab
      
      // En modo manual, filtramos las líneas de mensaje según la selección del usuario
      return this.transcripcionesLab.map(t => {
        const sels = this.mensajeSeleccionadosMan[t.twilio]
        if (sels && sels.length) {
          const msgsFilt = t.mensajes.filter((m, i) => sels.includes(i))
          return {
            ...t,
            mensajes: msgsFilt,
            texto_completo: msgsFilt.map(m => m.formato).join('\n'),
            total_mensajes: msgsFilt.length
          }
        }
        return t
      })
    },
    respuestaIAParsed: function () {
      if (this.analisisIA) return this.analisisIA
      if (!this.respuestaIA) return null
      try {
        const obj = typeof this.respuestaIA === 'string' ? JSON.parse(this.respuestaIA) : this.respuestaIA
        // Validar estructura mínima esperada
        if (obj && (obj.resumen || obj.diagnosis)) return obj
        return null
      } catch (e) {
        return null
      }
    },

    datosAuditoria: function () {
      const res = this.respuestaIAParsed
      const est = this.ultimaEstimacion
      
      const rateInput = 0.15 / 1000000
      const rateOutput = 0.60 / 1000000

      const data = {
        tokens: {
          estInput: est && est.tokens_input ? est.tokens_input : 0,
          realInput: res && res.usage && res.usage.input_tokens ? res.usage.input_tokens : 0,
          realOutput: res && res.usage && res.usage.output_tokens ? res.usage.output_tokens : 0,
          dev: 0
        },
        costos: {
          estTotal: est && est.costo_entrada_usd ? parseFloat(est.costo_entrada_usd) : 0,
          realInput: 0,
          realOutput: 0,
          realTotal: 0,
          dev: 0
        }
      }

      // Cálculos tokens
      data.tokens.dev = this.calcularDesviacion(data.tokens.estInput, data.tokens.realInput)
      
      // Cálculos costos
      data.costos.realInput = data.tokens.realInput * rateInput
      data.costos.realOutput = data.tokens.realOutput * rateOutput
      data.costos.realTotal = data.costos.realInput + data.costos.realOutput
      data.costos.dev = this.calcularDesviacion(data.costos.estTotal, data.costos.realInput)

      return data
    },

    diagnosticoIA: function () {
      const ia = this.respuestaIAParsed
      if (!ia) return null

      // Intentar extraer de diagnosis o de la raiz (soporte para ambos formatos)
      const diag = ia.diagnosis || {}
      
      return {
        resumen: diag.resumen || ia.resumen || '',
        hallazgos: diag.hallazgos_clave || [],
        patrones: diag.patrones_comunes || [],
        oportunidades: diag.oportunidades || [],
        recomendaciones: diag.recomendaciones || [],
        usage: ia.usage || null,
        metadatos: {
          elapsed: ia.elapsed_ms || 0,
          chats: ia.chats_analizados || 0
        }
      }
    }
  },

  data: function () {
    return {
      // Filtros
      fechaInicio: new Date(new Date().setDate(1)).toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      escuela: 1,
      plantelesSel: [],
      planteles: [],
      escuelas: [
        { id: 1, nombre: 'INBI' },
        { id: 2, nombre: 'FAST' }
      ],
      menuFechaInicio: false,
      menuFechaFin: false,

      // Estado
      cargando: false,
      datosCargados: false,

      embudo: {
        nivel1: { total: 0, por_fuente: [], lista: [] },
        nivel2: { completos: 0, incompletos: 0, lista_completos: [], lista_incompletos: [] },
        nivel3: { mas5: 0, menos5: 0, rescatados: 0, tasa_rescate: '0.00', lista_mas5: [], lista_menos5: [], lista_rescatados: [] },
        nivel4: { inscritos: 0, tasa_cierre: '0.00', promedio_respuesta_min: '0.00', lista: [] }
      },

      // Dialogo prospectos
      dialogNivel: false,
      tituloDialogo: '',
      prospectosDlg: [],
      headersProspectos: [
        { text: 'Nombre', value: 'nombre_completo' },
        { text: 'Fuente', value: 'fuente_limpia' },
        { text: 'Bot', value: 'tipo_bot' },
        { text: 'Interacciones', value: 'interacciones' },
        { text: 'Rescatado', value: 'es_rescatado' },
        { text: 'Inscrito', value: 'inscrito' },
        { text: 'Fecha', value: 'fecha_creacion' }
      ],

      // Laboratorio IA
      dialogLab: false,
      tituloLab: '',
      masterPrompt: '',
      nombrePrompt: '',
      promptSeleccionado: null,
      promptsGuardados: [],
      guardandoPrompt: false,
      cargandoTranscripciones: false,
      enviandoIA: false,
      infoTokens: null,
      respuestaIA: '',
      transcripcionesLab: [],
      filtrosLab: {
        fechaInicio: '',
        fechaFin: '',
        limitLeads: 50,
        limitMensajes: 15,
        menuInicio: false,
        menuFin: false,
        modoManual: false,
        prospectosSeleccionados: []
      },
      // Seleccion de mensajes manual
      dialogMensajesMan: false,
      prospectoMensajesMan: null,
      transcripcionMensajesMan: [],
      mensajeSeleccionadosMan: {}, // { twilio: [index, index] }
      verJSON: false,
      ultimaEstimacion: null,
      analisisIA: null,
      timeoutEst: null,

      // Snackbar
      snackbar: false,
      snackbarMsg: '',
      snackbarColor: 'success'
    }
  },

  mounted: function () {
    this.getPlanteles()
    this.consultar()
  },

  watch: {
    filtrosLab: {
      handler: function (val) {
        if (this.timeoutEst) clearTimeout(this.timeoutEst)
        this.timeoutEst = setTimeout(() => {
          this.previsualizarEnvio()
        }, 800)
      },
      deep: true
    }
  },

  methods: {
    mostrarCabeceraFecha: function (index) {
      if (index === 0) return true
      if (!this.transcripcionMensajesMan[index].timestamp || !this.transcripcionMensajesMan[index - 1].timestamp) return false
      
      const actual = this.transcripcionMensajesMan[index].timestamp.split('T')[0]
      const previa = this.transcripcionMensajesMan[index - 1].timestamp.split('T')[0]
      return actual !== previa
    },

    formatearFechaChat: function (fechaISO) {
      if (!fechaISO || fechaISO === 'N/A') return ''
      const d = new Date(fechaISO)
      const hoy = new Date()
      const ayer = new Date()
      ayer.setDate(hoy.getDate() - 1)

      if (d.toDateString() === hoy.toDateString()) return 'Hoy'
      if (d.toDateString() === ayer.toDateString()) return 'Ayer'

      const opciones = { weekday: 'long', day: 'numeric', month: 'long' }
      return d.toLocaleDateString('es-MX', opciones)
    },

    getPlanteles: function () {
      var self = this
      this.$http.get('kpi.planteles.all').then(function (response) {
        self.planteles = response.data || []
      }).catch(function (e) { console.log(e) })
    },

    consultar: async function () {
      if (!this.fechaInicio || !this.fechaFin) {
        this.mostrarSnack('Selecciona rango de fechas', 'error')
        return
      }
      this.cargando = true
      try {
        const res = await this.$http.post('/kpi.embudo.ventas', {
          escuela: this.escuela,
          planteles: this.plantelesSel,
          fechaInicio: this.fechaInicio,
          fechaFin: this.fechaFin
        })
        this.embudo = res.data
        this.datosCargados = true
        this.mostrarSnack('Datos del embudo actualizados', 'success')
      } catch (e) {
        console.error(e)
        this.mostrarSnack('Error al consultar el embudo', 'error')
      } finally {
        this.cargando = false
      }
    },

    abrirNivel: function (nivel, subgrupo) {
      this.prospectosDlg = []
      if (nivel === 1) {
        this.tituloDialogo = 'Nivel 1 — Todos los Contactos'
        this.prospectosDlg = this.embudo.nivel1.lista
      } else if (nivel === 2) {
        this.tituloDialogo = 'Nivel 2 — ' + (subgrupo === 'completos' ? 'Completos' : 'Incompletos')
        this.prospectosDlg = subgrupo === 'completos' ? this.embudo.nivel2.lista_completos : this.embudo.nivel2.lista_incompletos
      } else if (nivel === 3) {
        if (subgrupo === 'mas5') {
          this.tituloDialogo = 'Nivel 3 — Interacción +5'
          this.prospectosDlg = this.embudo.nivel3.lista_mas5
        } else if (subgrupo === 'menos5') {
          this.tituloDialogo = 'Nivel 3 — Menos de 5 Interacciones'
          this.prospectosDlg = this.embudo.nivel3.lista_menos5
        } else {
          this.tituloDialogo = 'Nivel 3 — Rescatados'
          this.prospectosDlg = this.embudo.nivel3.lista_rescatados
        }
      } else if (nivel === 4) {
        this.tituloDialogo = 'Nivel 4 — Inscritos'
        this.prospectosDlg = this.embudo.nivel4.lista
      }
      this.dialogNivel = true
    },

    abrirFuente: function (fuenteObj, subgrupo) {
      this.prospectosDlg = []
      const nombreFuente = fuenteObj.fuente || 'Sin fuente'
      
      if (subgrupo === 'total') {
        this.tituloDialogo = `Fuente: ${nombreFuente} — Todos`
        this.prospectosDlg = fuenteObj.lista || []
      } else if (subgrupo === 'completos') {
        this.tituloDialogo = `Fuente: ${nombreFuente} — Completos`
        this.prospectosDlg = fuenteObj.lista_completos || []
      } else if (subgrupo === 'incompletos') {
        this.tituloDialogo = `Fuente: ${nombreFuente} — Incompletos`
        this.prospectosDlg = fuenteObj.lista_incompletos || []
      }
      
      this.dialogNivel = true
    },

    abrirLab: async function (nivel, subgrupo) {
      this.nivelLab = nivel
      this.tituloLab = 'Nivel ' + nivel + (subgrupo ? ' (' + subgrupo + ')' : '')
      this.transcripcionesLab = []
      this.respuestaIA = ''
      this.masterPrompt = ''
      this.nombrePrompt = ''
      this.promptSeleccionado = null
      
      this.dialogLab = true
      this.infoTokens = null
      this.transcripcionesLab = []

      // Inicializar filtros (sin previsualizar aun)
      this.filtrosLab.fechaInicio = this.fechaInicio
      this.filtrosLab.fechaFin = this.fechaFin
      this.filtrosLab.limitLeads = 50
      this.filtrosLab.limitMensajes = 15
      this.filtrosLab.modoManual = false
      this.filtrosLab.prospectosSeleccionados = []
      this.mensajeSeleccionadosMan = {}

      // Cargar prompts desde la BD para este nivel
      await this.cargarPromptsGuardados(this.tituloLab)

      try {
        let leads = []
        if (nivel === 1) leads = this.embudo.nivel1.lista
        if (nivel === 2) leads = subgrupo === 'completos' ? this.embudo.nivel2.lista_completos : this.embudo.nivel2.lista_incompletos
        if (nivel === 3) {
          if (subgrupo === 'mas5') leads = this.embudo.nivel3.lista_mas5
          else if (subgrupo === 'menos5') leads = this.embudo.nivel3.lista_menos5
          else leads = this.embudo.nivel3.lista_rescatados
        }
        if (nivel === 4) leads = this.embudo.nivel4.lista

        if (!leads || !leads.length) {
          this.cargandoTranscripciones = false
          return
        }
        
        // ORDENAR POR INTERACCIONES (DESC) para priorizar activos en el muestreo de 50
        leads.sort((a, b) => (b.interacciones || 0) - (a.interacciones || 0))

        this.prospectosDlg = leads

        // Previsualizar inicialmente para cargar metadatos y transcripciones
        await this.previsualizarEnvio()
      } catch (e) {
        console.error(e)
        this.mostrarSnack('Error al abrir el laboratorio', 'error')
      } finally {
        this.cargandoTranscripciones = false
      }
    },

    previsualizarEnvio: async function () {
      if (!this.dialogLab) return // Evitar llamadas si el dialogo esta cerrado

      // Determinar Twilios a consultar
      let twilios = []
      if (this.filtrosLab.modoManual) {
        twilios = this.filtrosLab.prospectosSeleccionados.map(p => p.twilio)
      } else {
        const allTwilios = this.prospectosDlg.map(function (p) { return p.twilio })
        twilios = allTwilios.filter(function (v, i, a) { return v && a.indexOf(v) === i })
      }

      if (!twilios.length) {
        this.infoTokens = null
        this.transcripcionesLab = []
        return
      }

      this.cargandoTranscripciones = true
      try {
        var response = await this.$http.post('kpi.embudo.transcripciones', {
          escuela: this.escuela,
          twilios: twilios,
          fechaInicio: this.filtrosLab.fechaInicio,
          fechaFin: this.filtrosLab.fechaFin,
          limitLeads: this.filtrosLab.modoManual ? twilios.length : this.filtrosLab.limitLeads,
          limitMensajes: this.filtrosLab.modoManual ? 0 : this.filtrosLab.limitMensajes // 0 = sin limite en backend para luego filtrar manual
        })
        
        let transcripciones = response.data.transcripciones || []

        // Si es manual, filtrar lineas especificas
        if (this.filtrosLab.modoManual) {
          transcripciones = transcripciones.map(t => {
            const sels = this.mensajeSeleccionadosMan[t.twilio]
            if (sels && sels.length) {
              const msgsFilt = t.mensajes.filter((m, i) => sels.includes(i))
              return {
                ...t,
                mensajes: msgsFilt,
                texto_completo: msgsFilt.map(m => m.formato).join('\n'),
                total_mensajes: msgsFilt.length
              }
            }
            return t
          })
          
          // Recalcular tokens tras el filtrado manual en el cliente
          const tokens = Math.ceil(transcripciones.reduce((s, t) => s + (t.texto_completo ? t.texto_completo.length : 0), 0) / 4)
          const costo = (tokens / 1000000) * 0.15 // GPT-4o-mini: $0.15 por 1M tokens
          
          this.infoTokens = {
            procesados: twilios.length,
            total_prospectos: this.prospectosDlg.length,
            total_mensajes: transcripciones.reduce((s, t) => s + (t.mensajes ? t.mensajes.length : 0), 0),
            tokens_input: tokens,
            costo_entrada_usd: costo.toFixed(6)
          }
        } else {
          this.infoTokens = response.data.metadatos
        }

        this.transcripcionesLab = transcripciones
      } catch (e) {
        console.error(e)
      } finally {
        this.cargandoTranscripciones = false
      }
    },

    resetearFiltros: function () {
      this.filtrosLab.fechaInicio = this.fechaInicio
      this.filtrosLab.fechaFin = this.fechaFin
      this.filtrosLab.limitLeads = 50
      this.filtrosLab.limitMensajes = 15
      this.filtrosLab.modoManual = false
      this.filtrosLab.prospectosSeleccionados = []
      this.mensajeSeleccionadosMan = {}
      this.previsualizarEnvio()
    },

    abrirMensajesManual: async function (item) {
      this.prospectoMensajesMan = item
      this.transcripcionMensajesMan = []
      this.cargandoTranscripciones = true
      
      try {
        const res = await this.$http.post('kpi.embudo.transcripciones', {
          escuela: this.escuela,
          twilios: [item.twilio],
          fechaInicio: this.filtrosLab.fechaInicio,
          fechaFin: this.filtrosLab.fechaFin,
          limitLeads: 1,
          limitMensajes: 0
        })
        const data = res.data.transcripciones && res.data.transcripciones[0]
        this.transcripcionMensajesMan = data ? data.mensajes : []
        
        // Inicializar seleccion si no existe
        if (!this.mensajeSeleccionadosMan[item.twilio]) {
          this.$set(this.mensajeSeleccionadosMan, item.twilio, this.transcripcionMensajesMan.map((_, i) => i))
        }
        
        this.dialogMensajesMan = true
      } catch (e) {
        this.mostrarSnack('Error al cargar mensajes', 'error')
      } finally {
        this.cargandoTranscripciones = false
      }
    },

    enviarAIA: async function () {
      if (!this.transcripcionesActuales.length) {
        this.mostrarSnack('Primero previsualiza el envio', 'warning')
        return
      }
      this.enviandoIA = true
      this.respuestaIA = ''
      try {
        const res = await this.$http.post('/kpi.embudo.analizar', {
          nivel: this.tituloLab,
          master_prompt: this.masterPrompt,
          transcripciones: this.transcripcionesActuales.map(function (t) {
            return { twilio: t.twilio, texto: t.texto_completo }
          }),
          filtros: {
            escuela: this.escuela,
            planteles: this.plantelesSel,
            rango: [this.fechaInicio, this.fechaFin]
          }
        })
        
        // Guardar la ultima estimacion para comparar
        this.ultimaEstimacion = JSON.parse(JSON.stringify(this.infoTokens))

        // Guardar la respuesta completa para auditoria y vista estructurada
        this.analisisIA = res.data;

        if (res.data) {
          this.respuestaIA = typeof res.data === 'string'
            ? res.data
            : JSON.stringify(res.data, null, 2)
        }
        this.mostrarSnack('Analisis completado', 'success')
      } catch (e) {
        var detail = e.response && e.response.data && e.response.data.detail
          ? e.response.data.detail : null
        var message = e.response && e.response.data && e.response.data.message
          ? e.response.data.message : null
        this.mostrarSnack(detail || message || 'Error al comunicarse con la IA', 'error')
      } finally {
        this.enviandoIA = false
      }
    },

    /* ============================================================
       GESTION DE PROMPTS (DB Persistencia)
       ============================================================ */
    cargarPromptsGuardados: async function (nivel) {
      try {
        const res = await this.$http.get(`/kpi.ia.prompts/${nivel || ''}`)
        this.promptsGuardados = res.data || []
      } catch (e) { 
        this.promptsGuardados = [] 
        console.error('Error al cargar prompts', e)
      }
    },

    guardarPrompt: async function () {
      if (!this.nombrePrompt || !this.masterPrompt) {
        this.mostrarSnack('Escribe un nombre y el prompt', 'warning')
        return
      }
      this.guardandoPrompt = true
      try {
        await this.$http.post('/kpi.ia.prompts', {
          nombre: this.nombrePrompt,
          texto_prompt: this.masterPrompt,
          nivel_pertenece: this.tituloLab
        })
        this.mostrarSnack('Prompt guardado en la base de datos', 'success')
        this.nombrePrompt = ''
        await this.cargarPromptsGuardados(this.tituloLab)
      } catch (e) {
        this.mostrarSnack('Error al guardar prompt', 'error')
      } finally {
        this.guardandoPrompt = false
      }
    },

    eliminarPrompt: async function (id) {
      if (!confirm('¿Eliminar este prompt de la base de datos?')) return
      try {
        await this.$http.delete(`/kpi.ia.prompts/${id}`)
        this.mostrarSnack('Prompt eliminado', 'success')
        await this.cargarPromptsGuardados(this.tituloLab)
      } catch (e) {
        this.mostrarSnack('Error al eliminar', 'error')
      }
    },

    cargarPrompt: function () {
      var id = this.promptSeleccionado
      var p = this.promptsGuardados.find(function (x) { return x.id === id })
      if (p) this.masterPrompt = p.texto
    },

    /* ============================================================
       EXPORTS
       ============================================================ */
    exportarCSV: function (lista, nombre) {
      if (!lista.length) return
      var cols = Object.keys(lista[0])
      var rows = [cols.join(',')]
      lista.forEach(function (item) {
        rows.push(cols.map(function (c) {
          var val = item[c] != null ? item[c] : ''
          return '"' + String(val).replace(/"/g, '""') + '"'
        }).join(','))
      })
      var blob = new Blob([rows.join('\n')], { type: 'text/csv;charset=utf-8;' })
      var url = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = url
      a.download = nombre.replace(/\s+/g, '_') + '.csv'
      a.click()
      URL.revokeObjectURL(url)
    },

    exportarTranscripcionesJSON: function () {
      var str = JSON.stringify(this.transcripcionesActuales, null, 2)
      var blob = new Blob([str], { type: 'application/json' })
      var url = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = url
      a.download = 'transcripciones_' + this.tituloLab.replace(/\s+/g, '_') + '.json'
      a.click()
      URL.revokeObjectURL(url)
    },

    mostrarSnack: function (msg, color) {
      this.snackbarMsg = msg
      this.snackbarColor = color || 'success'
      this.snackbar = true
    },

    calcularDesviacion: function (est, real) {
      if (!est || !real) return 0
      var e = parseFloat(est)
      var r = parseFloat(real)
      if (e === 0) return 100
      var diff = Math.abs(r - e)
      return Math.round((diff / e) * 100)
    }
  }
}
</script>

<style scoped>
.embudo-nivel {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  border-radius: 8px !important;
}
.no-transition .v-expansion-panel-content {
  transition: none !important;
}
.border-bottom {
  border-bottom: 1px solid #e0e0e0 !important;
}
.border-top {
  border-top: 1px solid #e0e0e0 !important;
}
.border {
  border: 1px solid #e0e0e0 !important;
}
.embudo-nivel:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.18) !important;
}
.nivel-1 {
  background: linear-gradient(135deg, #1976D2, #42A5F5) !important;
  width: 100%;
}
.nivel-2 {
  background: linear-gradient(135deg, #2E7D32, #66BB6A) !important;
}
.nivel-2b {
  background: linear-gradient(135deg, #C62828, #EF5350) !important;
}
.nivel-3a {
  background: linear-gradient(135deg, #E65100, #FFA726) !important;
}
.nivel-3b {
  background: linear-gradient(135deg, #37474F, #78909C) !important;
}
.nivel-3c {
  background: linear-gradient(135deg, #00695C, #26A69A) !important;
}
.nivel-4 {
  background: linear-gradient(135deg, #4A148C, #9C27B0) !important;
}
</style>

<style scoped>
.chat-bubble {
  max-width: 85%;
  padding: 8px 12px;
  border-radius: 16px;
  position: relative;
  font-size: 0.85rem;
  line-height: 1.2rem;
}
.bubble-lead {
  background-color: #f1f8e9;
  border: 1px solid #dcedc8;
  color: #33691e;
  border-bottom-left-radius: 4px;
}
.bubble-bot {
  background-color: #e8eaf6;
  border: 1px solid #c5cae9;
  color: #1a237e;
  border-bottom-right-radius: 4px;
}
.shadow-sm {
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}
.w-100 {
  width: 100%;
}
.bg-resumen {
  background-color: #f3e5f5 !important;
}
.border-dashed {
  border-style: dashed !important;
}
.border-purple-light {
  border-color: #e8eaf6 !important;
}
.border-orange-light {
  border-color: #fff3e0 !important;
}
.border-blue-light {
  border-color: #e3f2fd !important;
}
.border-teal-light {
  border-color: #e0f2f1 !important;
}
.border-grey-light {
  border-color: #f5f5f5 !important;
}
.comparativa-table th {
  height: 32px !important;
  font-size: 0.75rem !important;
}
.comparativa-table td {
  height: 32px !important;
  font-size: 0.8rem !important;
}
.min-h-auto {
  min-height: auto !important;
}
.line-height-relaxed {
  line-height: 1.6;
}
.text-monospace-small {
  font-family: monospace;
  font-size: 0.75rem;
}
</style>
